// SUUMOスコア
const SuumoScore = {
  namespaced: true,

  state: {
    score: {
      building: 0,
      room: 0,
      total: 0,
      detail: {
        main_image: {
          score: 0,
          max_score: 0,
          item: {
            house_plan_image: false,
            exterior1: false,
            interior_category_6: false,
            interior_category_8: false,
            interior_category_9: false,
          },
        },
        sub_image: {
          score: 0,
          max_score: 0,
          item: {
            interior_category_2: false,
            interior_category_3: false,
            interior_category_4: false,
            interior_category_5: false,
            interior_category_7: false,
            interior_category_10: false,
            interior_category_11: false,
            interior_category_12: false,
            interior_category_13: false,
            interior_category_14: false,
            interior_category_15: false,
            interior_category_16: false,
            interior_category_17: false,
            interior_category_18: false,
            interior_category_19: false,
          },
        },
        near_image: {
          score: 0,
          max_score: 0,
          item: {
            near_image_category_2: false,
            near_image_category_3: false,
            near_image_category_4: false,
            near_image_category_5: false,
            near_image_category_6: false,
            near_image_category_7: false,
            near_image_category_8: false,
            near_image_category_9: false,
            near_image_category_10: false,
            near_image_category_11: false,
            near_image_category_13: false,
            near_image_category_14: false,
            near_image_category_15: false,
            near_image_category_16: false,
            near_image_category_17: false,
            near_image_category_18: false,
            near_image_category_19: false,
            near_image_category_20: false,
            near_image_category_21: false,
            near_image_category_22: false,
          },
        },
        catch: {
          score: 0,
          max_score: 0,
          item: {
            suumo_catch: false,
            suumo_net_catch: false,
          },
        },
      },
    },
    isStart: false,
  },
  getters: {
    getScore: state => {
      return state.score
    },
    getIsStart: state => {
      return state.isStart
    },
    getTotalScore: state => {
      return state.score.total
    },
    getDetail: state => {
      return state.score.detail
    },
  },
  mutations: {
    setScore(state, score) {
      state.score = score
    },
    setIsStart(state, start) {
      state.isStart = start
    },
  },
  actions: {},
}

export default SuumoScore
